// ** React Imports
import { useContext } from 'react'

// ** Component Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'

const CanViewNavGroup = props => {
  // ** Props
  const { children, navGroup } = props

  // ** Hook
  const ability = useContext(AbilityContext)

  const canSeeItem = item => {
    // During migration: if no ACL meta is provided, treat as visible.
    if (!(item?.action && item?.subject)) return true

    return ability && ability.can(item.action, item.subject)
  }

  const canViewMenuGroup = item => {
    const hasAnyVisibleChild = item.children && item.children.some(i => canSeeItem(i))
    if (!(item.action && item.subject)) {
      return hasAnyVisibleChild
    }

    return canSeeItem(item) && hasAnyVisibleChild
  }

  return navGroup && canViewMenuGroup(navGroup) ? <>{children}</> : null
}

export default CanViewNavGroup
